import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sliderarrow"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "extraImg"
}
const _hoisted_5 = { class: "count" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingImageWidget = _resolveComponent("LoadingImageWidget")!

  return (_ctx.media.length > 1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["media_card image_grid", [
      _ctx.media.length == 2 ? 'two_frame' : _ctx.media.length == 3 ? 'three_frame' : '',
      _ctx.showImageViewer ? 'mobile-details-view' : '',
      _ctx.post && _ctx.post.repostId ? 'informationPostMediaDv' : '',
    ]])
      }, [
        (_ctx.isDetailView || _ctx.showImageViewer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas fa-chevron-circle-left leftarrow", _ctx.selectedMediaIndex == 0 ? 'd-none' : '']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeIndex(-1)))
              }, null, 2),
              _createElementVNode("i", {
                class: _normalizeClass([_ctx.selectedMediaIndex == _ctx.media.length - 1 ? 'd-none' : '', "fas fa-chevron-circle-right rightarrow"]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIndex(1)))
              }, null, 2)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.media, (image, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: image }, [
            (
          (!_ctx.isDetailView && !_ctx.showImageViewer) || index == _ctx.selectedMediaIndex
        )
              ? (_openBlock(), _createElementBlock("figure", {
                  key: 0,
                  onClick: _withModifiers(($event: any) => (_ctx.handleShowImageViewer(image)), ["stop","prevent"]),
                  class: _normalizeClass([
            index < 4 ? '' : 'hide',
            !image.type.includes('video')
              ? 'loadingImageContainer adsadad'
              : '',
          ])
                }, [
                  (!image.type.includes('video'))
                    ? (_openBlock(), _createBlock(_component_LoadingImageWidget, {
                        key: 0,
                        imageUrl: image.url
                      }, null, 8, ["imageUrl"]))
                    : (_openBlock(), _createElementBlock("video", {
                        key: 1,
                        src: image.url
                      }, null, 8, _hoisted_3)),
                  (index == 3 && _ctx.media.length > 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, "+" + _toDisplayString(_ctx.media.length - (index + 1)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_2))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["media_card image_frame single_image", _ctx.post && _ctx.post.repostId ? 'informationPostMediaDv' : ''])
      }, [
        _createElementVNode("figure", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleShowImageViewer(_ctx.media[0]))),
          class: _normalizeClass({ loadingImageContainer: _ctx.media[0].type.includes('image') })
        }, [
          (_ctx.media[0].type.includes('image'))
            ? (_openBlock(), _createBlock(_component_LoadingImageWidget, {
                key: 0,
                imageUrl: _ctx.media[0].url
              }, null, 8, ["imageUrl"]))
            : (_ctx.media[0].type.includes('audio'))
              ? (_openBlock(), _createElementBlock("audio", {
                  key: 1,
                  controls: "",
                  src: _ctx.media[0].url
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("video", {
                  key: 2,
                  controls: "",
                  src: _ctx.media[0].url
                }, null, 8, _hoisted_7))
        ], 2)
      ], 2))
}